export default "<ng-content class=\"vfs-table-container\" [ngClass]=\"dataSource.loading ? 'vfs-hide-table' : 'vfs-table'\"></ng-content>";